module.exports = __webpack_public_path__ + "static/media/Josh-Kilen-Headshot.71237ad8.jpeg";